var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeatDiaryViewProgEntries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ae8fea;}.cls-2{fill:#784ace;}.cls-3{fill:#ccc;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heat_cycle_progesterone_view_entries"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.41,61.69c-36.65,0-66.35,26.72-66.35,59.68V539.13c0,33,29.7,59.68,66.35,59.68H531.9c36.66,0,66.35-26.7,66.35-59.68V121.37c0-33-29.69-59.68-66.35-59.68H67.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.41,61.69c-36.65,0-66.35,26.86-66.35,59.68v89.52H598.25V121.37c0-32.82-29.69-59.68-66.35-59.68H67.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.53,2A29.84,29.84,0,0,0,78.69,31.85v89.52a29.84,29.84,0,1,0,59.68,0V31.85A29.84,29.84,0,0,0,108.53,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M482.57,2C466.1,2,452.73,14,452.73,31.85v89.52c0,14.92,13.37,29.84,29.84,29.84s29.84-14.92,29.84-29.84V31.85C512.41,14,499,2,482.57,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M395.11,303.2a93.69,93.69,0,0,0-30.55-33.8h0c-12.86-8.53-26.67-12.85-41-12.85H237.43a30.57,30.57,0,0,0-31,31V505.81c0,8.58,2.74,15.93,8.13,21.82a28.17,28.17,0,0,0,21.39,9.21c8.81,0,16.11-3,21.69-8.93s8.21-13.23,8.21-22.1V442.45h57.7c14.38,0,28.19-4.32,41-12.85a93.11,93.11,0,0,0,30.56-34,98.25,98.25,0,0,0,0-92.38Zm-62.67,76.12h0c-3.18,2.75-6.1,4.09-8.92,4.09h-57.7V316h57.7c2.86,0,5.81,1.3,9,4a35,35,0,0,1,9.18,12.64,41.2,41.2,0,0,1,0,33.82A36.73,36.73,0,0,1,332.44,379.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatDiaryViewProgEntries);
export default __webpack_public_path__ + "static/media/heat_diary_view_prog_entries.e954388f060d992754ecdd34f31a4dff.svg";
export { ForwardRef as ReactComponent };